<template>
    <CCard class="scroll-bar">
        <div class="input-group mb-3">
            <input
                type="text"
                class="form-control border-0 bg-light"
                :placeholder="$t('product.search_group')"
                aria-label="Username"
                aria-describedby="basic-addon1"
                v-model="searchProductGroup"
            />
        </div>
        <template v-if="searchProductGroup.length === 0">
            <div v-for="item in productGroups" :key="item._id">
                <CustomCollapse @emitCollapse="emitGroup" :item="item" />
            </div>
        </template>
        <template v-else-if="!notFoundProductGroup">
            <div v-for="item in foundedProductGroup" :key="item._id">
                <CustomCollapse @emitCollapse="emitGroup" :item="item" />
            </div>
        </template>
        <p v-else-if="notFoundProductGroup" class="text-danger">{{ $t('product.not_found') }}</p>
    </CCard>
</template>

<script>
import { mapGetters } from 'vuex'
import CustomCollapse from './CustomCollapse'

export default {
    name: 'GroupSearch',

    components: {
        CustomCollapse
    },

    data() {
        return {
            searchProductGroup: '',
            foundedProductGroup: [],
            notFoundProductGroup: false,
        }
    },

    computed: {
        ...mapGetters({
            productGroups: 'scraperGroup/productGroups',
        }),
    },

    methods: {
        nesting(array, text) {
            for (let i = 0; i < array.length; i++) {
                array[i].title_fa.startsWith(text) ? this.foundedProductGroup.push(array[i]) : null
                if (array[i].childs && array[i].childs.length > 0) {
                    this.nesting(array[i].childs, text)
                }
            }
        },
        emitGroup() {
            this.$emit('emitGroup')
        }
    },

    watch: {
        searchProductGroup(text) {
            if (text) {
                this.foundedProductGroup = []
                this.notFoundProductGroup = false
                this.nesting(this.productGroups, text)
                if (this.foundedProductGroup.length === 0) {
                    this.notFoundProductGroup = true
                }
            }
        },
    }
}
</script>
<style scoped>
.scroll-bar {
    width: 220px;
    height: 200px;
    overflow-y: scroll;
    padding: 10px;
    margin-bottom: 5px;
}
.scroll-bar::-webkit-scrollbar {
    display: none;
}
</style>